function initQuickCardProducts() {
  document.querySelectorAll(".quick-card-product").forEach((card) => {
    if (card.dataset.quickCardInited) return;
    card.dataset.quickCardInited = "true";

    const productData = JSON.parse(card.dataset.productJson);
    const form = card.querySelector(".quick-add-form");
    const variantIdInput = form.querySelector("input[name='id']");
    const productPrice = card.querySelector(".quick-card-product__price");
    const priceEl = card.querySelector(".quick-card-product__current-price");
    const comparePriceEl = card.querySelector(
      ".quick-card-product__compare-price"
    );
    const imageEl = card.querySelector(".quick-card-product__image");

    // ===== MAIN UPDATE FUNCTION =====
    function updateVariant() {
      const selectedOptions = [];

      // Collect selected radios
      card.querySelectorAll(".card-product__option-radios").forEach((group) => {
        const pos = parseInt(group.dataset.optionPosition) - 1;
        const checked = group.querySelector("input[type='radio']:checked");
        if (checked) selectedOptions[pos] = checked.value;
      });

      // Handle color option
      const colorBtn = card.querySelector(".card-product__color-option.active");
      if (colorBtn) {
        const colorValue = colorBtn.dataset.value;
        const colorOptionIndex = productData.options.indexOf("Color");
        if (colorOptionIndex > -1)
          selectedOptions[colorOptionIndex] = colorValue;
      }

      // Find matching variant
      const matchedVariant = productData.variants.find((v) =>
        v.options.every((opt, i) => opt === selectedOptions[i])
      );

      if (matchedVariant) {
        variantIdInput.value = matchedVariant.id;

        priceEl.textContent = Shopify.formatMoney(
          matchedVariant.price,
          window.money_without_trailing_zeros_format
        );

        if (matchedVariant.compare_at_price > matchedVariant.price) {
          comparePriceEl.textContent = Shopify.formatMoney(
            matchedVariant.compare_at_price,
            window.money_without_trailing_zeros_format
          );
          productPrice.classList.add("discounted");
          comparePriceEl.style.display = "inline";
        } else {
          comparePriceEl.style.display = "none";
          productPrice.classList.remove("discounted");
        }

        if (matchedVariant.featured_image) {
          imageEl.src = matchedVariant.featured_image.src.replace(
            /(\.[^.]*)$/,
            "_1000x$1"
          );
          imageEl.alt = matchedVariant.featured_image.alt || productData.title;
        }

        updateAvailability(matchedVariant);
      }

      updateOptionAvailability(selectedOptions);
    }

    function updateVariantPlus() {
      card
        .querySelectorAll('input[type="radio"]')
        .forEach((r) => r.classList.remove("checked"));
      updateVariant();
    }

    // ===== UPDATE ADD TO CART BUTTON =====
    function updateAvailability(variant) {
      const addToCartBtn = card.querySelector(".quick-add-button");
      if (variant.available) {
        addToCartBtn.textContent = window.addText;
        addToCartBtn.disabled = false;
      } else {
        addToCartBtn.textContent = window.soldOutText;
        addToCartBtn.disabled = true;
      }
    }

    // ===== UPDATE SOLD OUT STATES =====
    function updateOptionAvailability(selectedOptions) {
      card.querySelectorAll(".card-product__option-radios").forEach((group) => {
        const optionIndex = parseInt(group.dataset.optionPosition) - 1;
        group.querySelectorAll("label").forEach((label) => {
          const radio = label.querySelector("input");
          const testOptions = [...selectedOptions];
          testOptions[optionIndex] = radio.value;

          const matchingVariant = productData.variants.find((v) =>
            v.options.every((val, i) => val === testOptions[i])
          );

          if (!matchingVariant || !matchingVariant.available) {
            label.classList.add("sold-out");
          } else {
            label.classList.remove("sold-out");
          }
        });
      });

      // Color availability
      const colorOptionIndex = productData.options.indexOf("Color");
      if (colorOptionIndex > -1) {
        card.querySelectorAll(".card-product__color-option").forEach((btn) => {
          const colorValue = btn.dataset.value;
          const testOptions = [...selectedOptions];
          testOptions[colorOptionIndex] = colorValue;

          const matchingVariant = productData.variants.find((v) =>
            v.options.every((val, i) => val === testOptions[i])
          );

          if (!matchingVariant || !matchingVariant.available) {
            btn.classList.add("disabled");
          } else {
            btn.classList.remove("disabled");
          }
        });
      }
    }

    // ===== AUTO-SELECT FIRST AVAILABLE VARIANT =====
    function selectFirstAvailable() {
      const firstAvailable =
        productData.variants.find((v) => v.available) ||
        productData.variants[0];
      if (!firstAvailable) return;

      // Set color active
      const colorOptionIndex = productData.options.indexOf("Color");
      if (colorOptionIndex > -1) {
        const colorValue = firstAvailable.options[colorOptionIndex];
        const colorBtn = card.querySelector(
          `.card-product__color-option[data-value="${CSS.escape(colorValue)}"]`
        );
        if (colorBtn) colorBtn.classList.add("active");
      }

      // Check radios

      firstAvailable.options.forEach((opt, i) => {
        const radio = card.querySelector(
          `.card-product__option-radios[data-option-position="${
            i + 1
          }"] input[value="${CSS.escape(opt)}"]`
        );

        if (radio) {
          radio.checked = true;
          radio.classList.add("checked");
        }
      });
    }

    // ===== EVENT LISTENERS =====
    card
      .querySelectorAll(".card-product__option-radios input[type='radio']")
      .forEach((radio) => {
        radio.addEventListener("change", updateVariantPlus);
      });

    card.querySelectorAll(".card-product__color-option").forEach((btn) => {
      btn.addEventListener("click", () => {
        card
          .querySelectorAll(".card-product__color-option")
          .forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        updateVariantPlus();
      });
    });

    // ===== INITIAL STATE =====
    selectFirstAvailable();
    updateVariant();
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initQuickCardProducts();
  window.initQuickCardProducts = initQuickCardProducts;
});
